import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css';

// Pages set their own <title>/<meta>/<link>/<script> tags directly in JSX
// (no react-helmet-async): React 19 hoists title/meta/link to <head>
// natively. react-helmet-async was tried here first but conflicts with that
// native hoisting specifically on routes reached via useParams(), leaving
// <title> empty — see git history on this file for the full writeup.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
